export const mergeUserFullName = ({ firstName = '', lastName = '' }) => {
  return `${firstName} ${lastName}`.trim();
};
